import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import noteService from "../../services/noteService";
import { FaEdit, FaTrash, FaPlus, FaSearch } from "react-icons/fa";

const CreditNoteList = () => {
  const [notes, setNotes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchNotes = async () => {
    try {
      const data = await noteService.getCreditNotes();
      setNotes(data);
    } catch (error) {
      console.error("Error fetching credit notes:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this credit note?")) {
      try {
        await noteService.deleteCreditNote(id);
        fetchNotes();
      } catch (error) {
        console.error("Error deleting credit note:", error);
      }
    }
  };

  const filteredNotes = notes.filter(
    (note) =>
      note.note_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (note.reason && note.reason.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div style={{ padding: "24px", maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#1a202c" }}>
          Credit Notes
        </h2>
        <Link
          to="/dashboard/credit-notes/new"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #00aaff 0%, #0077cc 100%)",
            color: "white",
            padding: "10px 20px",
            borderRadius: "10px",
            textDecoration: "none",
            fontWeight: "600",
            boxShadow: "0 4px 14px rgba(0, 119, 204, 0.3)",
          }}
        >
          <FaPlus /> Add Credit Note
        </Link>
      </div>

      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div style={{ position: "relative", marginBottom: "20px", maxWidth: "400px" }}>
          <FaSearch
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#a0aec0",
            }}
          />
          <input
            type="text"
            placeholder="Search notes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px 10px 40px",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              outline: "none",
            }}
          />
        </div>

        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #f7fafc" }}>
                <th style={tableHeaderStyle}>Note #</th>
                <th style={tableHeaderStyle}>Date</th>
                <th style={tableHeaderStyle}>Amount</th>
                <th style={tableHeaderStyle}>Reason</th>
                <th style={tableHeaderStyle}>Status</th>
                <th style={tableHeaderStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                    Loading...
                  </td>
                </tr>
              ) : filteredNotes.length > 0 ? (
                filteredNotes.map((note) => (
                  <tr key={note.id} style={{ borderBottom: "1px solid #f7fafc" }}>
                    <td style={tableCellStyle}>{note.note_number}</td>
                    <td style={tableCellStyle}>
                      {new Date(note.date).toLocaleDateString()}
                    </td>
                    <td style={{ ...tableCellStyle, fontWeight: "600" }}>
                      {new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED' }).format(note.total_amount)}
                    </td>
                    <td style={tableCellStyle}>{note.reason}</td>
                    <td style={tableCellStyle}>
                      <span style={getStatusBadgeStyle(note.status)}>
                        {note.status}
                      </span>
                    </td>
                    <td style={tableCellStyle}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <Link to={`/dashboard/credit-notes/edit/${note.id}`} style={{ color: "#4a5568" }}>
                          <FaEdit />
                        </Link>
                        <button
                          onClick={() => handleDelete(note.id)}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "#f56565" }}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                    No credit notes found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  textAlign: "left",
  padding: "16px",
  color: "#718096",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "uppercase",
};

const tableCellStyle = {
  padding: "16px",
  color: "#4a5568",
  fontSize: "15px",
};

const getStatusBadgeStyle = (status) => {
  const styles = {
    completed: { background: "#f0fff4", color: "#2f855a" },
    draft: { background: "#ebf8ff", color: "#2b6cb0" },
  };
  return {
    padding: "4px 10px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
    ...(styles[status] || {}),
  };
};

export default CreditNoteList;
